import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@beautyburst/tokens/css';
import '@beautyburst/ui/styles';
import './styles.css';
import { BRAND_LOGO } from '@beautyburst/ui';
import { BrowserCustomerApp } from './browser-app.tsx';
import { customerAsset } from './base-path.ts';

const root = document.querySelector('#root');

if (!(root instanceof HTMLElement)) {
  throw new Error('Beauty Burst could not find the application root.');
}

const favicon = document.querySelector<HTMLLinkElement>('#beauty-burst-favicon');
if (favicon !== null) favicon.href = customerAsset(BRAND_LOGO.mark);

createRoot(root).render(
  <StrictMode>
    <BrowserCustomerApp />
  </StrictMode>,
);
